var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToWishlist({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M980 5109 c-161 -31 -299 -174 -330 -340 -7 -35 -9 -863 -8 -2381 l3 -2326 24 -26 c25 -27 76 -42 108 -32 11 3 320 238 688 520 l669 515 35 -28 c193 -150 1257 -965 1286 -985 21 -14 49 -26 62 -26 33 0 80 26 95 53 10 17 14 175 18 700 l5 679 89 34 c401 155 681 508 745 941 47 314 -58 663 -278 922 -110 130 -295 259 -467 325 l-89 34 -5 544 c-5 534 -6 544 -28 599 -61 152 -175 251 -321 279 -67 13 -2236 12 -2301 -1z m2320 -229 c24 -14 58 -45 75 -68 l30 -44 3 -519 3 -519 -108 0 c-394 0 -758 -197 -977 -530 -197 -299 -244 -688 -124 -1028 165 -469 605 -782 1101 -782 l107 0 0 -531 0 -531 -37 28 c-21 16 -291 223 -601 461 -309 238 -576 439 -592 448 -35 18 -67 19 -96 2 -11 -7 -291 -220 -621 -474 -331 -255 -604 -463 -607 -463 -12 0 -7 4356 5 4411 15 69 85 142 150 157 28 6 449 10 1144 9 l1100 -2 45 -25z m164 -1375 c235 -41 443 -163 589 -346 281 -351 281 -847 0 -1198 -304 -381 -857 -472 -1260 -209 -202 132 -347 329 -415 564 -20 68 -23 102 -23 244 0 185 14 255 80 397 94 203 276 386 469 473 186 83 370 108 560 75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3238 3061 l-33 -29 -3 -180 -3 -180 -179 -4 -180 -3 -31 -32 c-45 -44 -45 -102 0 -146 l31 -32 180 -3 179 -4 3 -180 3 -180 33 -29 c46 -41 99 -40 141 2 l31 31 0 178 0 178 178 4 c152 3 181 6 204 21 58 39 58 135 0 174 -23 15 -52 18 -204 21 l-178 4 0 178 0 178 -31 31 c-42 42 -95 43 -141 2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToWishlist);
export default __webpack_public_path__ + "static/media/add-to-wishlist.61b5dc06701dff9433af40055d840d54.svg";
export { ForwardRef as ReactComponent };